/**
 * HAPIVERI / Ayurveda Quiz
 * - Dawn 流の Web Component (Custom Element) として実装
 * - 完全クライアントサイドで動作（回答データを外部に送信しない）
 * - 設問データはこのファイル内に定義（将来 schema blocks 化も可）
 */

(function () {
  'use strict';

  // ========================================
  // 設問データ
  // 各 option の dosha プロパティが V/P/K のどれに加点するかを示す
  // ========================================
  const QUESTIONS = [
    {
      q: 'もともとの体格に近いものは？',
      options: [
        { label: '痩せ型・骨が細く、体重が増えにくい', dosha: 'vata' },
        { label: '中肉中背・筋肉がつきやすい', dosha: 'pitta' },
        { label: 'がっしり・体重が増えやすい', dosha: 'kapha' }
      ]
    },
    {
      q: '肌の質感は？',
      options: [
        { label: '乾燥しやすく、ひんやり感じやすい', dosha: 'vata' },
        { label: '赤みやほてりが出やすく、温かい', dosha: 'pitta' },
        { label: 'しっとり・脂性気味で潤いがある', dosha: 'kapha' }
      ]
    },
    {
      q: '髪質に近いのは？',
      options: [
        { label: '細くパサつきやすい・くせ毛', dosha: 'vata' },
        { label: '柔らかい直毛・白髪や薄毛になりやすい', dosha: 'pitta' },
        { label: '太く豊か・ツヤがある', dosha: 'kapha' }
      ]
    },
    {
      q: '食欲・お腹の空き方は？',
      options: [
        { label: 'ムラがある・うっかり食べ忘れることもある', dosha: 'vata' },
        { label: '強く規則的・空腹を我慢するのが苦手', dosha: 'pitta' },
        { label: 'ゆっくり一定・抜いても平気', dosha: 'kapha' }
      ]
    },
    {
      q: '食事のスピード・量の傾向は？',
      options: [
        { label: '早食い・量は少なめ', dosha: 'vata' },
        { label: '中くらいのペースでしっかり食べる', dosha: 'pitta' },
        { label: 'ゆっくり・量は多めになりがち', dosha: 'kapha' }
      ]
    },
    {
      q: '睡眠の傾向は？',
      options: [
        { label: '眠りが浅い・寝つきが悪い', dosha: 'vata' },
        { label: '中程度・寝汗をかきやすい', dosha: 'pitta' },
        { label: '深く長く眠る・朝が起きにくい', dosha: 'kapha' }
      ]
    },
    {
      q: 'ふだんの思考・性格は？',
      options: [
        { label: '発想が豊か・心配や不安を感じやすい', dosha: 'vata' },
        { label: '集中力が高い・完璧主義気味', dosha: 'pitta' },
        { label: '穏やか・粘り強く落ち着いている', dosha: 'kapha' }
      ]
    },
    {
      q: 'ストレスを感じたときの反応は？',
      options: [
        { label: '不安になる・落ち着かない', dosha: 'vata' },
        { label: 'イライラ・怒りっぽくなる', dosha: 'pitta' },
        { label: '無気力・引きこもりたくなる', dosha: 'kapha' }
      ]
    },
    {
      q: '暑さ・寒さの感じ方は？',
      options: [
        { label: '寒がり・冷えやすい', dosha: 'vata' },
        { label: '暑がり・汗っかき', dosha: 'pitta' },
        { label: '湿気やどんよりした天気が苦手', dosha: 'kapha' }
      ]
    },
    {
      q: '体力・エネルギーの傾向は？',
      options: [
        { label: '瞬発型・持久力は低めで疲れやすい', dosha: 'vata' },
        { label: '中程度・目的があると粘れる', dosha: 'pitta' },
        { label: '持久力が高い・スタミナ型', dosha: 'kapha' }
      ]
    },
    {
      q: '日常の動き・話し方は？',
      options: [
        { label: '動き・話し方ともに速い', dosha: 'vata' },
        { label: '無駄がなく計画的・効率重視', dosha: 'pitta' },
        { label: 'ゆっくり・落ち着いて安定している', dosha: 'kapha' }
      ]
    },
    {
      q: '苦手・不調を感じやすい季節は？',
      options: [
        { label: '秋〜冬（乾燥や寒さ）', dosha: 'vata' },
        { label: '夏（暑さや湿度）', dosha: 'pitta' },
        { label: '春・梅雨（だるさ・むくみ）', dosha: 'kapha' }
      ]
    }
  ];

  // ========================================
  // 結果データ（タイプ別の説明と食・暮らしのヒント）
  // ========================================
  const RESULTS = {
    vata: {
      name: 'ヴァータ（風）タイプ',
      summary:
        '軽やかで創造的、変化を楽しむタイプ。感性が豊かで動きが速い反面、冷えや乾燥、不規則さで疲れやすい一面も。リズムを整えると本来の伸びやかさが戻ります。',
      food: [
        '温かく、しっとりとした料理（スープ・煮込み・お粥など）を中心に',
        '根菜・白米・ごま油・ギーなど、ほんのり甘く油分のある食材を取り入れる',
        '冷たい飲み物・生野菜・炭酸・ドライフルーツは控えめに'
      ],
      life: [
        '毎日できるだけ同じ時間に食事と就寝を意識する',
        'ぬるめのお湯にゆったりつかり、足元を温める',
        '予定を詰め込みすぎず、深い呼吸でリズムを取り戻す時間を持つ'
      ]
    },
    pitta: {
      name: 'ピッタ（火）タイプ',
      summary:
        '情熱的で集中力が高く、目標に向かって突き進むタイプ。一方で熱がこもりやすく、頑張りすぎや苛立ちが出やすい傾向も。ほどよくクールダウンする時間が大切です。',
      food: [
        '葉物野菜・瓜類・ココナッツ・甘味のある果物など、体を冷ます穏やかな食材を中心に',
        '辛味・酸味・塩味の強いもの、揚げ物、アルコールは控えめに',
        '常温〜ぬるめの水分をこまめに取り、空腹で長時間我慢しない'
      ],
      life: [
        '激しい運動より、自然のなかでのウォーキングや水辺の散策を',
        '「予定の8割」で動くつもりで、ゆとりを残す',
        '夜は強い光や情報を控え、月明かりのような穏やかな環境で過ごす'
      ]
    },
    kapha: {
      name: 'カパ（土・水）タイプ',
      summary:
        '穏やかで安定感があり、忍耐強いタイプ。包容力がある一方で、停滞すると重さやだるさを感じやすい傾向も。軽やかな動きと刺激で、本来のゆたかさが引き出されます。',
      food: [
        '温かく軽めの料理を中心に。豆類・葉物野菜・苦味や辛味のある食材を取り入れる',
        '脂っこいもの・甘いもの・乳製品・冷たいものは控えめに',
        '朝はしっかり、夜は軽めのバランスを意識する'
      ],
      life: [
        '朝の散歩・ストレッチなど、体を動かす習慣を取り入れる',
        '同じ環境にとどまらず、新しい人や場所に少しずつ触れる',
        '昼寝は短めにし、活動的に過ごす時間を意識的につくる'
      ]
    }
  };

  // ========================================
  // Custom Element 定義
  // ========================================
  class AyurvedaQuiz extends HTMLElement {
    constructor() {
      super();
      this.questions = QUESTIONS;
      this.results = RESULTS;
      this.answers = []; // 各設問で選んだ dosha を格納
      this.currentIndex = 0;
    }

    connectedCallback() {
      // 各画面要素の参照
      this.screens = {
        intro: this.querySelector('[data-screen="intro"]'),
        quiz: this.querySelector('[data-screen="quiz"]'),
        result: this.querySelector('[data-screen="result"]')
      };
      this.questionTextEl = this.querySelector('[data-question-text]');
      this.optionsEl = this.querySelector('[data-options]');
      this.progressBarEl = this.querySelector('[data-progress-bar]');
      this.progressTextEl = this.querySelector('[data-progress-text]');
      this.prevBtn = this.querySelector('[data-action="prev"]');
      this.nextBtn = this.querySelector('[data-action="next"]');
      this.startBtn = this.querySelector('[data-action="start"]');
      this.restartBtn = this.querySelector('[data-action="restart"]');
      this.resultTypeEl = this.querySelector('[data-result-type]');
      this.resultSummaryEl = this.querySelector('[data-result-summary]');
      this.adviceFoodEl = this.querySelector('[data-advice-food]');
      this.adviceLifeEl = this.querySelector('[data-advice-life]');

      // イベントバインド
      this.startBtn?.addEventListener('click', this.handleStart.bind(this));
      this.prevBtn?.addEventListener('click', this.handlePrev.bind(this));
      this.nextBtn?.addEventListener('click', this.handleNext.bind(this));
      this.restartBtn?.addEventListener('click', this.handleRestart.bind(this));
    }

    // ========================================
    // 画面切替
    // ========================================
    showScreen(name) {
      Object.entries(this.screens).forEach(([key, el]) => {
        if (!el) return;
        if (key === name) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    // ========================================
    // ハンドラー
    // ========================================
    handleStart() {
      this.answers = new Array(this.questions.length).fill(null);
      this.currentIndex = 0;
      this.showScreen('quiz');
      this.renderQuestion();
      // スクリーンリーダー用に問題見出しへフォーカス
      requestAnimationFrame(() => this.questionTextEl?.focus());
    }

    handlePrev() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1;
        this.renderQuestion();
        requestAnimationFrame(() => this.questionTextEl?.focus());
      }
    }

    handleNext() {
      // 未回答ならガード
      if (!this.answers[this.currentIndex]) return;

      if (this.currentIndex < this.questions.length - 1) {
        this.currentIndex += 1;
        this.renderQuestion();
        requestAnimationFrame(() => this.questionTextEl?.focus());
      } else {
        this.calculateResult();
        this.showScreen('result');
        // 結果見出しへフォーカス
        requestAnimationFrame(() => this.resultTypeEl?.focus());
        // ページ内遷移時に結果トップが見えるようにスムーズスクロール
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    handleRestart() {
      this.answers = [];
      this.currentIndex = 0;
      this.showScreen('intro');
      this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // ========================================
    // 設問描画
    // ========================================
    renderQuestion() {
      const item = this.questions[this.currentIndex];
      const total = this.questions.length;
      const progressPct = Math.round(((this.currentIndex + 1) / total) * 100);

      // プログレスバー
      if (this.progressBarEl) this.progressBarEl.style.width = progressPct + '%';
      if (this.progressTextEl)
        this.progressTextEl.textContent = `Q${this.currentIndex + 1} / ${total}`;

      // 設問テキスト
      if (this.questionTextEl) this.questionTextEl.textContent = item.q;

      // 選択肢
      this.optionsEl.innerHTML = '';
      item.options.forEach((opt, idx) => {
        const li = document.createElement('li');
        li.className = 'ayurveda-quiz__option';

        const inputId = `ayurveda-q${this.currentIndex}-opt${idx}`;
        const isChecked = this.answers[this.currentIndex] === opt.dosha;

        const label = document.createElement('label');
        label.className = 'ayurveda-quiz__option-label';
        label.setAttribute('for', inputId);

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = `ayurveda-q${this.currentIndex}`;
        input.id = inputId;
        input.value = opt.dosha;
        input.className = 'ayurveda-quiz__option-input';
        input.checked = isChecked;
        input.addEventListener('change', () => {
          this.answers[this.currentIndex] = opt.dosha;
          this.updateNextButton();
        });

        const text = document.createElement('span');
        text.className = 'ayurveda-quiz__option-text';
        text.textContent = opt.label;

        label.appendChild(input);
        label.appendChild(text);
        li.appendChild(label);
        this.optionsEl.appendChild(li);
      });

      // 戻るボタン
      this.prevBtn.disabled = this.currentIndex === 0;

      // 次へ・結果へ
      this.updateNextButton();
      this.nextBtn.textContent =
        this.currentIndex === this.questions.length - 1 ? '結果を見る' : '次へ';
    }

    updateNextButton() {
      this.nextBtn.disabled = !this.answers[this.currentIndex];
    }

    // ========================================
    // 結果計算
    // ========================================
    calculateResult() {
      const counts = { vata: 0, pitta: 0, kapha: 0 };
      this.answers.forEach((d) => {
        if (d && counts[d] !== undefined) counts[d] += 1;
      });

      const total = counts.vata + counts.pitta + counts.kapha || 1;

      // 最多のドーシャを判定（同点時はランダム性を避けるため V > P > K の順で判定）
      const order = ['vata', 'pitta', 'kapha'];
      let topDosha = order[0];
      order.forEach((d) => {
        if (counts[d] > counts[topDosha]) topDosha = d;
      });

      const result = this.results[topDosha];

      // タイプ表示
      this.resultTypeEl.textContent = result.name;
      this.resultSummaryEl.textContent = result.summary;

      // スコアバー
      ['vata', 'pitta', 'kapha'].forEach((d) => {
        const pct = Math.round((counts[d] / total) * 100);
        const fill = this.querySelector(`[data-bar="${d}"]`);
        const pctEl = this.querySelector(`[data-pct="${d}"]`);
        if (fill) {
          // フェードイン演出のため少し遅延
          requestAnimationFrame(() => {
            fill.style.width = pct + '%';
          });
        }
        if (pctEl) pctEl.textContent = pct + '%';
      });

      // 食事のヒント
      this.adviceFoodEl.innerHTML = '';
      result.food.forEach((t) => {
        const li = document.createElement('li');
        li.textContent = t;
        this.adviceFoodEl.appendChild(li);
      });

      // 暮らしのヒント
      this.adviceLifeEl.innerHTML = '';
      result.life.forEach((t) => {
        const li = document.createElement('li');
        li.textContent = t;
        this.adviceLifeEl.appendChild(li);
      });
    }
  }

  if (!customElements.get('ayurveda-quiz')) {
    customElements.define('ayurveda-quiz', AyurvedaQuiz);
  }
})();
